import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
let DemoColFixed = class DemoColFixed extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
        this.pinFirst = true;
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column width="120" .position=${this.pinFirst ? 'fixed' : 'initial'}>
          Stock
          <cds-inline-button @click=${() => this.pinFirst = !this.pinFirst} aria-label="pin column" cds-layout="align:right">
            <cds-icon shape="pin" ?solid=${this.pinFirst}></cds-icon>
          </cds-inline-button>
        </cds-grid-column>
        <cds-grid-column width="400">Average</cds-grid-column>
        <cds-grid-column width="400">Current</cds-grid-column>
        <cds-grid-column width="400">About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoColFixed.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoColFixed.prototype, "pinFirst", void 0);
DemoColFixed = __decorate([
    customElement('demo-col-fixed')
], DemoColFixed);
export { DemoColFixed };
//# sourceMappingURL=demo.column-fixed.js.map